import type { ErrorMessages } from '@repo/types/messages/errors';

import { ErrorCodes } from '#errorCodes';

export const baseErrorMessages: ErrorMessages = {
  400: {
    title: 'Błąd żądania',
    detail: 'Nieprawidłowe parametry żądania lub brak wymaganych pól',
  },
  401: {
    title: 'Błąd autoryzacji',
    detail: 'Token jest nieprawidłowy lub go brakuje',
  },
  403: {
    title: 'Brak uprawnień',
    detail: 'Użytkownik nie ma wymaganych uprawnień',
  },
  404: {
    title: 'Nie znaleziono',
    detail: 'Żądany zasób nie został znaleziony',
  },
  500: {
    title: 'Błąd serwera',
    detail: 'Wystąpił wewnętrzny błąd serwera.',
  },
  [ErrorCodes.EMAIL.SEND_FAILED]: {
    title: 'Nie udało się wysłać e-maila',
    detail: 'Serwer pocztowy nie przyjął wiadomości. Spróbuj ponownie za chwilę.',
  },
  [ErrorCodes.GENERIC.INTERNAL_SERVER_ERROR_500]: {
    title: 'Błąd',
    detail: 'Coś poszło nie tak.',
  },
  [ErrorCodes.DB.FOREIGN_KEY_CONSTRAINT]: {
    title: 'Błąd danych',
    detail: 'Nie można wykonać tej operacji.',
  },
  [ErrorCodes.DB.VALIDATION]: {
    title: 'Błąd walidacji',
    detail: 'Popraw dane i spróbuj ponownie.',
  },
  [ErrorCodes.DB.DB_ERR]: {
    title: 'Błąd bazy danych',
    detail: 'Spróbuj ponownie później.',
  },
  [ErrorCodes.DB.CONN]: {
    title: 'Brak połączenia',
    detail: 'Nie można połączyć z bazą danych.',
  },
  [ErrorCodes.DB.S3_DOWNLOAD]: {
    title: 'Błąd pobierania',
    detail: 'Nie udało się pobrać pliku.',
  },
  [ErrorCodes.AUTH.WRONG_CREDENTIALS]: {
    title: 'Błędne dane logowania',
    detail: 'Sprawdź swoje dane logowania i spróbuj ponownie.',
  },
  [ErrorCodes.AUTH.ACCOUNT_DEACTIVATED]: {
    title: 'Konto dezaktywowane',
    detail: 'Twoje konto zostało dezaktywowane. Skontaktuj się z administratorem.',
  },
  [ErrorCodes.AUTH.NO_CRED_AND_NO_TOKEN]: {
    title: 'Brak danych logowania',
    detail: 'Brak danych logowania i tokenu. Zaloguj się ponownie.',
  },
  [ErrorCodes.AUTH.TOKEN_NOT_VALID]: {
    title: 'Nieprawidłowy token',
    detail: 'Token jest nieprawidłowy lub wygasł. Zaloguj się ponownie.',
  },
  [ErrorCodes.AUTH.ALREADY_SIGNED_UP]: {
    title: 'Już zarejestrowany',
    detail: 'Konto z tymi danymi już istnieje.',
  },
  [ErrorCodes.AUTH.NO_CRED]: {
    title: 'Brak danych logowania',
    detail: 'Brak wymaganych danych logowania.',
  },
  [ErrorCodes.AUTH.TEACHER_AUTH]: {
    title: 'Brak uprawnień nauczyciela',
    detail: 'Musisz być nauczycielem, aby wykonać tę operację.',
  },
  [ErrorCodes.AUTH.ADMIN_AUTH]: {
    title: 'Brak uprawnień administratora',
    detail: 'Musisz być administratorem, aby wykonać tę operację.',
  },
};
